import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/apiClient';
import { useAuthStore } from '@/auth/authStore';
import { Perm } from '@/auth/permissions';
import { Modules } from '@/core/modules/moduleKeys';
import { useModuleStore } from '@/core/modules/moduleStore';
import { propertyKeys } from './api/property';

interface AirportPortfolio { id: string; code: string; name: string }

/** The menu shows the Airport entry only where a portfolio the person can see has the airport pack on. */
export const AIRPORT_FEATURE = 'property.airport';

/**
 * Tells the menu what the property module's set-up holds. Mounted once in the signed-in layout; the answer is cached and
 * re-asked when a pack is switched (every property change invalidates the property queries).
 */
export function usePropertyNavFeatures(): void {
  const moduleOn = useModuleStore((s) => s.enabled[Modules.Property] === true);
  const canView = useAuthStore((s) => s.hasPermission(Perm.Property.View));
  const setFeature = useModuleStore((s) => s.setFeature);
  const airports = useQuery({
    queryKey: [...propertyKeys.all, 'airport', 'portfolios'],
    enabled: moduleOn && canView,
    staleTime: 60_000,
    queryFn: async () => (await apiClient.get<AirportPortfolio[]>('/api/v1/property/airport/portfolios')).data,
  });
  useEffect(() => {
    if (!moduleOn || !canView) setFeature(AIRPORT_FEATURE, false);
    else if (airports.data) setFeature(AIRPORT_FEATURE, airports.data.length > 0);
  }, [moduleOn, canView, airports.data, setFeature]);
}
